import React, { useState } from "react";
import { StyleSheet, Text, View, ActivityIndicator, TouchableWithoutFeedback } from "react-native";

function getWrapperStyle(disabled, loading, pressed) {
  if (loading) {
    return styles.loadingWrapper;
  }

  if (disabled) {
    return styles.disabledWrapper;
  }

  if (pressed) {
    return styles.pressedWrapper;
  }

  return styles.defaultWrapper;
}

function getTextStyle(disabled, loading, pressed) {
  if (loading) {
    return styles.loadingText;
  }

  if (disabled) {
    return styles.disabledText;
  }

  if (pressed) {
    return styles.pressedText;
  }

  return styles.defaultText;
}

export default function LoaderButton({
  onPress,
  label,
  loading,
  disabled
}: {
  onPress: () => void;
  label: string;
  loading: boolean;
  disabled: boolean;
}) {
  const [pressed, setPressed] = useState(false);
  const wrapperStyle = getWrapperStyle(disabled, loading, pressed);
  const textStyle = getTextStyle(disabled, loading, pressed);
  return <TouchableWithoutFeedback disabled={disabled || loading} onPress={onPress} onPressIn={() => setPressed(true)} onPressOut={() => setPressed(false)}>
      <View style={wrapperStyle}>
        <View style={styles.activityIndicator} />
        <Text selectable={false} style={textStyle}>
          {label}
        </Text>
        {loading ? <ActivityIndicator style={styles.activityIndicator} /> : <View style={styles.activityIndicator} />}
      </View>
    </TouchableWithoutFeedback>;
}
const wrapperCommon = {
  borderColor: "#AAAAAA",
  borderWidth: 1,
  borderRadius: 5,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row"
};
const textCommon = {
  fontSize: 20
};
const styles = StyleSheet.create({
  disabledWrapper: { ...wrapperCommon,
    backgroundColor: "#CCCCCC"
  },
  loadingWrapper: { ...wrapperCommon,
    backgroundColor: "#FFFFFF"
  },
  pressedWrapper: { ...wrapperCommon,
    backgroundColor: "#FFFFFF"
  },
  defaultWrapper: { ...wrapperCommon,
    backgroundColor: "#FFFFFF"
  },
  disabledText: { ...textCommon,
    color: "#AAAAAA"
  },
  loadingText: { ...textCommon,
    color: "#AAAAAA"
  },
  pressedText: { ...textCommon,
    color: "#AAAAAA"
  },
  defaultText: { ...textCommon,
    color: "#666666"
  },
  activityIndicator: {
    width: 36,
    height: 36
  }
});